import React from 'react'
import { shallow } from 'enzyme'
import Segment from '../Segment'
import Row from '../Row'
import Adjustment from '../Adjustment'
import DebtAdjustment from '../DebtAdjustment'
import SegmentFooter from '../SegmentFooter'

import loan from './testData/loan'


describe('<Segment />', () => {
  let wrapper, instance, props
  describe('#renderFooter', () => {
    beforeEach(() => {
      props = {
        categories: [
          { key: 'net_profit', title: 'Net Profit', }
        ],
        data: [],
        years: new Map(),
        loan
      }
      wrapper = shallow(<Segment {...props} />)
      instance = wrapper.instance()
    })
    it('should return something', () => {
      expect(instance.renderFooter()).toBeTruthy()
    })
  })
})
